/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const ShowPass = {

	$domShowPass: $('.js-show-pass'),
	$domIconShow: $('.icon-show'),
	$domIconHide: $('.icon-hide'),

	init: function() {
		ShowPass.$domShowPass.on('click', ShowPass.togglePass);
	},

	togglePass: function(e) {
		const _self = e.currentTarget;
		const input = $(_self).siblings('input')[0];

		if (input.type === 'password') {
			input.type = 'text';
			$(_self).find(ShowPass.$domIconHide).attr( "style", "display: inline-block;" );
			$(_self).find(ShowPass.$domIconShow).attr( "style", "display: none;" );
		} else {
			input.type = 'password';
			$(_self).find(ShowPass.$domIconHide).attr( "style", "display: none;" );
			$(_self).find(ShowPass.$domIconShow).attr( "style", "display: inline-block;" );
		}

	}
};

export default ShowPass;
